import React from "react";
import useConsensusGroups from "../hooks/useConsensusGroups";
import { GroupLegend, ConsensusRefLink } from "./ConsensusBadge";

/**
 * Compact page banner that tells users the numbers shown here have a
 * consensus tier, with a live count and a link to the authoritative view.
 *
 * Drop it just below your page header for instant context.
 */
export default function PageConsensusBanner({ className = "", testId = "page-consensus-banner" }) {
  const consensus = useConsensusGroups();
  return (
    <div
      className={`bg-gradient-to-r from-slate-50 to-slate-100 border border-slate-200 rounded-lg px-3 py-2 flex items-center justify-between flex-wrap gap-2 text-[11px] ${className}`}
      data-testid={testId}
    >
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-bold text-slate-700">🚦 Numbers on this page also belong to a Consensus group:</span>
        <GroupLegend groups={consensus.groups} />
      </div>
      <ConsensusRefLink />
    </div>
  );
}
